var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 1.41667H12.75V0.708333C12.75 0.520472 12.6754 0.340304 12.5425 0.207466C12.4097 0.0746278 12.2295 0 12.0417 0C11.8538 0 11.6736 0.0746278 11.5408 0.207466C11.408 0.340304 11.3333 0.520472 11.3333 0.708333V1.41667H5.66667V0.708333C5.66667 0.520472 5.59204 0.340304 5.4592 0.207466C5.32636 0.0746278 5.14619 0 4.95833 0C4.77047 0 4.5903 0.0746278 4.45747 0.207466C4.32463 0.340304 4.25 0.520472 4.25 0.708333V1.41667H3.54167C2.6027 1.41779 1.70252 1.79129 1.03857 2.45524C0.374625 3.11919 0.00112473 4.01937 0 4.95833L0 13.4583C0.00112473 14.3973 0.374625 15.2975 1.03857 15.9614C1.70252 16.6254 2.6027 16.9989 3.54167 17H13.4583C14.3973 16.9989 15.2975 16.6254 15.9614 15.9614C16.6254 15.2975 16.9989 14.3973 17 13.4583V4.95833C16.9989 4.01937 16.6254 3.11919 15.9614 2.45524C15.2975 1.79129 14.3973 1.41779 13.4583 1.41667ZM1.41667 4.95833C1.41667 4.39475 1.64055 3.85425 2.03906 3.45573C2.43758 3.05722 2.97808 2.83333 3.54167 2.83333H13.4583C14.0219 2.83333 14.5624 3.05722 14.9609 3.45573C15.3595 3.85425 15.5833 4.39475 15.5833 4.95833V5.66667H1.41667V4.95833ZM13.4583 15.5833H3.54167C2.97808 15.5833 2.43758 15.3595 2.03906 14.9609C1.64055 14.5624 1.41667 14.0219 1.41667 13.4583V7.08333H15.5833V13.4583C15.5833 14.0219 15.3595 14.5624 14.9609 14.9609C14.5624 15.3595 14.0219 15.5833 13.4583 15.5833Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.6875C9.0868 11.6875 9.5625 11.2118 9.5625 10.625C9.5625 10.0382 9.0868 9.5625 8.5 9.5625C7.9132 9.5625 7.4375 10.0382 7.4375 10.625C7.4375 11.2118 7.9132 11.6875 8.5 11.6875Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95801 11.6875C5.54481 11.6875 6.02051 11.2118 6.02051 10.625C6.02051 10.0382 5.54481 9.5625 4.95801 9.5625C4.37121 9.5625 3.89551 10.0382 3.89551 10.625C3.89551 11.2118 4.37121 11.6875 4.95801 11.6875Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.042 11.6875C12.6288 11.6875 13.1045 11.2118 13.1045 10.625C13.1045 10.0382 12.6288 9.5625 12.042 9.5625C11.4552 9.5625 10.9795 10.0382 10.9795 10.625C10.9795 11.2118 11.4552 11.6875 12.042 11.6875Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCalendar);
export default __webpack_public_path__ + "static/media/fi-rr-calendar.cfbce60f1932bd70e8cc31de5fee9854.svg";
export { ForwardRef as ReactComponent };